import { useMediaQuery } from "@mui/material"
import { ReactNode } from "react"
import { Theme } from "theme/theme"

export const useIsDesktop = () =>
  useMediaQuery<Theme>((theme) => theme.breakpoints.up("md"))

// MUI v7: Hidden component removed, use useMediaQuery instead
export const Mobile = ({ children }: { children: ReactNode }) => {
  const isDesktop = useIsDesktop()
  return isDesktop ? null : <>{children}</>
}

export const Desktop = ({ children }: { children: ReactNode }) => {
  const isDesktop = useIsDesktop()
  return isDesktop ? <>{children}</> : null
}

export const IEMediaQuery =
  "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)"

export const EdgeMediaQuery = "@supports (-ms-ime-align:auto)"
